import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    closeIcon: {
        position: 'absolute'
    }
}));

export default useStyles;